import { h } from 'preact'
import styles from './LogoSection.module.css'

const emLogoBig = require('../../static/em-logo-big.svg').default

export function LogoSection() {
  return (
    <div class={styles['dh-fotball-banner__logoSection']}>
      <div
        class={styles['dh-fotball-banner__logoSection-logo']}
        style={`background-image: url(${emLogoBig});`}
      >
        FOTBALL-EM
      </div>
      <div class={styles['dh-fotball-banner__logoSection-links']}>
        <a href="https://resultater.nrk.no/fotball/1/hoydepunkter">SE HØYDEPUNKTER</a>
        <a href="https://resultater.nrk.no/">ALLE KAMPER</a>
      </div>
    </div>
  )
}
